import {
  REQUEST_DASHBOARD_MESSAGES,
  FETCH_DASHBOARD_MESSAGES_SUCCESS,
  FETCH_DASHBOARD_MESSAGES_FAILURE,
  POST_DASHBOARD_MESSAGE,
  POST_MESSAGE_SUCCESS,
  POST_MESSAGE_FAILURE,
  REQUEST_CONSOLIDATED_STATISTICS,
  FETCH_CONSOLODATED_STATISTICS_SUCCESS,
  FETCH_CONSOLODATED_STATISTICS_FAILURE,
} from '../actions/type';

const INITIAL_STATE = {
  messages: [],
  messagesIsLoading: false,
  messagesError: null,

  postingMessage: false,
  postMessagesSuccess: null,
  postMessageError: null,

  consolodatedStatistics: null,
  consolodatedStatisticsIsLoading: false,
  consolodatedStatisticsError: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    // Request for messages on General Dashboard
    case REQUEST_DASHBOARD_MESSAGES:
      return { ...state, messages: [], messagesIsLoading: true, messagesError: null };
    case FETCH_DASHBOARD_MESSAGES_SUCCESS:
      return { ...state, messagesIsLoading: false, messages: action.payload.data };
    case FETCH_DASHBOARD_MESSAGES_FAILURE:
      return { ...state, messagesIsLoading: false, messagesError: action.payload.data };

    // Request to post message
    case POST_DASHBOARD_MESSAGE:
      return { ...state, postingMessage: true, postMessageError: null, postMessagesSuccess: null };
    case POST_MESSAGE_SUCCESS:
      return { ...state, postingMessage: false, postMessagesSuccess: true, messages: action.payload.data };
    case POST_MESSAGE_FAILURE:
      return { ...state, postingMessage: false, postMessageError: action.payload.data };

    // Request for consolodated statistics
    case REQUEST_CONSOLIDATED_STATISTICS:
      return { ...state, consolodatedStatisticsIsLoading: true, consolodatedStatistics: null, consolodatedStatisticsError: null };
    case FETCH_CONSOLODATED_STATISTICS_SUCCESS:
      return { ...state, consolodatedStatisticsIsLoading: false, consolodatedStatistics: action.payload.data };
    case FETCH_CONSOLODATED_STATISTICS_FAILURE:
      return { ...state, consolodatedStatisticsIsLoading: false, consolodatedStatisticsError: action.payload.data };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/dashboard_reducer.js